import { Stack } from "@mui/material";
import React from "react";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import NullCheck from "./NullCheck";

const Map = ({ width, borderRadius, height,position }) => {

  return (
    <NullCheck valueForCheck={position}>
      <Stack
        width={width ? width : "100%"}
        borderRadius={borderRadius ?? "0"}
        borderColor="white"
      >
        <MapContainer
          style={{
            borderRadius: borderRadius ?? "0",
            height: height ? height : 250,
          }}
          center={position}
          zoom={18}
          minZoom={14}
          maxZoom={18}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            {/* <Popup>{data?.bizName}</Popup> */}
          </Marker>
        </MapContainer>
      </Stack>
    </NullCheck>
  );
};
export default Map;
